<div class="file-field">
    <div class="d-flex justify-content-center">
        <div class="btn btn--paybee btn--black" [ngClass]="getClassList()">
            <span style="text-transform: none;">{{label}}</span>
            <input *ngIf="multiple" #field (change)="onChange($event)" (click)="onClick()" type="file" [accept]="accept" [disabled]="disabled" multiple />
            <input *ngIf="!multiple" #field (change)="onChange($event)" (click)="onClick()" type="file" [accept]="accept" [disabled]="disabled" />
        </div>
    </div>
</div>